import {exists} from 'shared/utils/custom-utils';
import type {OverallStatsDataParams, PublicStatsDataParams} from './types';
import type {ValueEditorBindings} from 'shared/value-editors/kp-value-editor/types';
import type {EditedProperty} from 'typings/portaro.be.types';

export function getColorFromString(str: string, lightness: number = 70, opacity?: number): string {
    if (str === '') {
        return `hsl(0, 0%, ${lightness}%)`;
    }

    const hues = [0, 20, 30, 40, 50, 60, 80, 120, 160, 190, 210, 230, 260, 290, 330, 360];
    const goldenFrac = 0.5 * (3 - Math.sqrt(5));
    const x = (simpleHash(str) * goldenFrac % 1.0) * (hues.length - 1);
    const i = Math.floor(x);
    const f = x % 1.0;
    const hue = (1.0 - f) * hues[i] + f * hues[i + 1];

    if (exists(opacity)) {
        return `hsla(${Math.round(hue * 100) / 100}, 100%, ${lightness}%, ${opacity})`;
    }

    return `hsl(${Math.round(hue * 100) / 100}, 100%, ${lightness}%)`;
}

function simpleHash(str: string): number {
    const prime = 67;
    let hash = 7;

    for (let i = 0; i < str.length; i++) {
        hash = (hash * prime + str.charCodeAt(i)) % 10000;
    }

    return hash;
}

// Plugin for ChartJS adding bottom margin to chart legend
export const legendMarginChartJSPlugin = {
    id: 'legendMargin',
    afterInit(chart: any, args: any, plugins: any) {
        const originalFit = chart.legend.fit;
        const margin = plugins.margin || 0;
        chart.legend.fit = function fit() {
            if (originalFit) {
                originalFit.call(this);
            }

            return this.height += margin;
        }
    }
};

export function findEditorBindingsInFields(fields: EditedProperty[], fieldName: string): ValueEditorBindings | null {
    return fields.find((field) => field.fieldName === fieldName)?.editor ?? null;
}

export function findEditorLabelInFields(fields: EditedProperty[], fieldName: string): string {
    return fields.find((field) => field.fieldName === fieldName)?.label ?? '';
}

export function filterPublicStatsParams(publicParams: PublicStatsDataParams): PublicStatsDataParams {
    const {fromDate, toDate, timeGranularity} = publicParams;
    return {fromDate, toDate, timeGranularity};
}

export function filterOverallStatsParams(overallParams: OverallStatsDataParams): OverallStatsDataParams {
    const {fromDate, toDate, department, location} = overallParams;
    return {fromDate, toDate, department, location: location ?? []};
}